import { render, staticRenderFns } from "./FreezeCard.vue?vue&type=template&id=e11ecff2&scoped=true"
import script from "./FreezeCard.vue?vue&type=script&lang=js"
export * from "./FreezeCard.vue?vue&type=script&lang=js"
import style0 from "./FreezeCard.vue?vue&type=style&index=0&id=e11ecff2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e11ecff2",
  null
  
)

export default component.exports